<template>
    <div class="rejoignez-flc">
        <Navbar />
        <!--=============== HOME ===============-->
        <div class="section bg-white" id="home">
            <div class="hero-image">
                <div class="hero-text">
                    <!-- <h1 class="__title">Nous aspirons à rendre nos produits <span class="color">disponibles</span> pour tous</h1> -->
                    <h1 class="__title">Entreprise</h1>
                </div>
            </div>
        </div>

        <div class="bg-white">
            <div class="content" id="banner">
                <div class="row">
                    <div class="col-md-6">
                        <img class="image-business" src="../assets/images/partenaire3.png" alt="Entreprise" />
                    </div>
                    <div class="col-md-6">
                        <p class="titre-entreprise"><b>Je suis une entreprise</b></p>
                        <p class="description-entreprise">
                            Chez Fruits et Légumes du Congo, notre principal produit est le saka saka, et nous sommes
                            fiers d'être votre fournisseur. Notre approche de collaboration avec les entreprises est
                            axée sur la flexibilité et la satisfaction de nos clients. <br>

                            Nos partenaires commerciaux ont la possibilité de commander un minimum de 10 produits par
                            livraison, ce qui leur permet de répondre à leurs besoins en toute simplicité. Nous
                            comprenons que chaque entreprise a des exigences uniques, c'est pourquoi nous laissons nos
                            clients fixer leurs propres créneaux de livraison. Vous êtes libre de nous contacter à tout
                            moment, selon votre convenance. <br>

                            Pour simplifier le processus de commande, nous avons mis en place un système de commande en
                            ligne intuitif sur notre site web. Cela signifie que vous pouvez passer vos commandes
                            rapidement et facilement, sans avoir besoin de faire des appels téléphoniques. <br>

                            En choisissant de collaborer avec FLC, vous avez la possibilité de personnaliser vos plages
                            horaires de livraison selon vos besoins. De plus, nous sommes heureux d'offrir la livraison
                            gratuite, quelle que soit votre localisation. Nous sommes déterminés à rendre votre
                            expérience avec nous aussi pratique et avantageuse que possible.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <Footer />
    </div>
</template>

<script>
    import Navbar from "../components/Navbar.vue";
    import Footer from "../components/Footer.vue";

    export default {
        name: "Entreprise",
        components: {
            Navbar,
            Footer,
        },
        data() {
            return {
                message: "Rejoignez-nous aujourd'hui",
                test: true,
            };
        },
        methods: {
            afficherTel() {
                // console.log(this.test)
                if (this.test === true) {
                    this.message = "+242 06 667 53 32";
                    this.test = false
                } else {
                    this.message = "Rejoignez-nous aujourd'hui";
                    this.test = true
                }
            },
            openWhatsApp() {
                const phoneNumber = '+242066675332'; // remplacer par votre numéro de téléphone
                const message = 'Bonjour, j\'aimerais devenir partenaire de FLC'; // message pré-rempli
                window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`, '_blank');
            }
        }
    }
</script>

<style scoped>

    .content {
        padding: 2rem 0 2rem;
    }
    .titre-entreprise {
        font-size: 30px;
    }

    .description-entreprise {
        text-align: justify;
    }

    .__title {
        line-height: 60px;
        color: #fff;
        transition: .2s;
        font-size: 48px;
        font-weight: bold;
    }

    .hero-image {
        background-image: url("../assets/images/partenaire2.png");
        background-color: #cccccc;
        height: 460px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }

    .hero-text {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .color {
        background-color: #D8F0F0;
        /* Couleur de fond du sélecteur */
        color: black;
    }



    /*========== NAZO'S BUSINESS ==========*/

    .image-business {
        width: 100%;
    }

    .titre-business {
        font-size: 30px;
        color: #fff;
    }

    .text-business {
        text-align: justify;
        font-size: 13px;
        color: #fff;
    }

    .top-left {
        position: relative;
        top: -330px;
        left: 16px;
    }

    .box-business {
        text-align: initial;
        width: 48%;
        padding: 2rem;
    }

    .box-business-two {
        width: 100%;
    }

    .sub-box-business-two {
        background-color: rgb(46, 46, 46);
        padding: 1rem;
    }

    .titre-business-two,
    .text-business-two {
        color: white;
    }

    .box-content-business {
        margin: 0;
        padding: 0;
        height: 300px;
    }


    /* lorsque l'écran est inférieur à 992px */
    @media (max-width: 992px) {
        .titre-business {
            font-size: 35px;
        }

        .text-business {
            font-size: 13px;
        }
    }

    @media (max-width: 840px) {
        .titre-business {
            font-size: 28px;
        }
    }

    @media (max-width: 767px) {
        .text-business {
            font-size: 12px;
        }

        .hero-image {
            top: -90px;
            margin-bottom: 0px;
        }

        .section {
            padding: 4.5rem 0 0.5rem;
        }

        .content {
            padding: 0.3rem 0 0.5rem;
        }

        .__title {
            line-height: 40px;
            color: #fff;
            transition: .2s;
            font-size: 37px;
            font-weight: bold;
        }

        .titre-entreprise {
            margin-top: 20px;
            font-size: 30px;
        }
    }

    @media (max-width: 672px) {
        .titre-business {
            font-size: 25px;
        }

        .text-business {
            font-size: 12px;
        }
    }

    @media (max-width: 654px) {
        .box-content-business {
            display: none;
        }
    }

    @media (min-width: 654px) {
        .box-content-business-two {
            display: none;
        }
    }

    @media (min-width: 768px) {
        .section {
            padding: 3rem 0 2rem;
        }
    }
</style>